export default __webpack_public_path__ + "static/media/play.53cb986b.png";